// extracted by mini-css-extract-plugin
export default {"errorPage":"not-found-module__errorPage__wtLp1"};